"use client";

import { useSignupDialog } from "@/contexts/SignupDialogContext";
import { LoginDialog } from "./assistant/login-dialog";

export default function GlobalSignupDialog() {
  const { open, setOpen } = useSignupDialog();
  return <LoginDialog open={open} onOpenChange={setOpen} />;
}
